import { ResetPasswordForm } from '@/pages/reset-password/ResetPasswordForm';

export const ResetPasswordPage = () => (
  <div className="flex h-full w-full items-center justify-center">
    <div className="bg-white flex sm:rounded-lg p-7 w-full h-full sm:w-96 sm:h-auto">
      <ResetPasswordForm />
    </div>
  </div>
);
